<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import { idToVSkill } from '../skill/skills';

  export let skillId: number;

  $: src = `/images/vskills/${
    $idToVSkill.get(skillId)?.icon?.replace('VSkillIcon_', '') ?? 'EmptySlot'
  }.webp`;
</script>

<img class="vskill-image" {src} alt={'VSkill'} {...$$restProps} />
